export default "__VITE_ASSET__6021b230__"